import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlayerStop = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 9L9 10V30L10 31H30L31 30V10L30 9H10Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcPlayerStop);
export { ForwardRef as ReactComponent };
